import React, { FC, useMemo } from 'react'
import { Modal, Tabs } from 'antd'
import { useLocalization } from 'localization'
import { useHideModal } from 'components/Modals'
import IntegrationsTab from '../IntegrationsTab'
import ScanTab from '../ScanTab'
import Container from 'components/Container'
import CustomCSVUpload from '../CustomCSVUpload'
import { useIsWealthicaUser } from 'modules/common/hooks'
import WealthicaTab from '../WealthicaTab'

const AddIntegrationModal: FC = () => {
	const { t } = useLocalization()
	const hideModal = useHideModal()
	const onClose = () => {
		hideModal()
	}
	const isWealthicaUser = useIsWealthicaUser()

	const tabKeys = useMemo(
		() => ({
			INTEGRATIONS: t('terms.integrations'),
			WEALTHICA: t('terms.wealthica'),
			BLOCKCHAIN: t('terms.blockchain'),
			CSV: t('actions.csvUpload'),
		}),
		[t]
	)

	return (
		<Modal
			title={<Container display="flex">{t('actions.import')}</Container>}
			width={700}
			open
			onCancel={onClose}
			footer={null}
		>
			<Tabs defaultActiveKey={isWealthicaUser ? tabKeys.WEALTHICA : tabKeys.INTEGRATIONS} size="small">
				{isWealthicaUser ? (
					<Tabs.TabPane tab={tabKeys.WEALTHICA} key={tabKeys.WEALTHICA}>
						<WealthicaTab />
					</Tabs.TabPane>
				) : (
					<Tabs.TabPane tab={tabKeys.INTEGRATIONS} key={tabKeys.INTEGRATIONS}>
						<IntegrationsTab />
					</Tabs.TabPane>
				)}
				<Tabs.TabPane tab={tabKeys.BLOCKCHAIN} key={tabKeys.BLOCKCHAIN}>
					<ScanTab />
				</Tabs.TabPane>
				<Tabs.TabPane tab={tabKeys.CSV} key={tabKeys.CSV}>
					<CustomCSVUpload />
				</Tabs.TabPane>
			</Tabs>
		</Modal>
	)
}

export default AddIntegrationModal
